import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { studentApi, STUDENT, STUDENT_TOKEN_KEY } from "../../../../globals/api-config";

const StudentAuthContext = createContext(null);

export function StudentAuthProvider({ children }) {
  const [student, setStudent] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem(STUDENT_TOKEN_KEY);
    if (!token) {
      setLoading(false);
      return;
    }
    studentApi
      .get(STUDENT.me)
      .then((res) => setStudent(res.data.student))
      .catch(() => localStorage.removeItem(STUDENT_TOKEN_KEY))
      .finally(() => setLoading(false));
  }, []);

  function persist(data) {
    if (data.token) localStorage.setItem(STUDENT_TOKEN_KEY, data.token);
    setStudent(data.student);
  }

  async function signup(payload) {
    const res = await studentApi.post(STUDENT.signup, payload);
    persist(res.data);
    return res.data.student;
  }

  async function login(email, password) {
    const res = await studentApi.post(STUDENT.login, { email, password });
    persist(res.data);
    return res.data.student;
  }

  async function logout() {
    try {
      await studentApi.post(STUDENT.logout);
    } catch {
      // ignore
    }
    localStorage.removeItem(STUDENT_TOKEN_KEY);
    setStudent(null);
  }

  const value = useMemo(
    () => ({ student, loading, isLoggedIn: !!student, signup, login, logout }),
    [student, loading]
  );

  return <StudentAuthContext.Provider value={value}>{children}</StudentAuthContext.Provider>;
}

export function useStudentAuth() {
  return useContext(StudentAuthContext);
}
